/**
 * Phase 45 Plan 45-08 — task time-entries read-only query hook.
 *
 * Wraps GET /api/tasks/:taskId/entries (added in this plan). Read-only;
 * logging continues via the timesheet flow (LogTimePopover on MyTasks).
 */
import { useQuery } from '@tanstack/react-query';
import {
  type TaskTimeEntryDto,
  fetchTaskTimeEntries,
} from '../services/api/taskTimeEntries';

export const taskTimeEntriesQueryKey = (taskId: number) =>
  ['tasks', taskId, 'entries'] as const;

export function useTaskTimeEntries(taskId: number | null) {
  return useQuery<TaskTimeEntryDto[]>({
    queryKey:
      taskId != null
        ? taskTimeEntriesQueryKey(taskId)
        : ['tasks', 'noop', 'entries'],
    queryFn: () => fetchTaskTimeEntries(taskId as number),
    enabled: taskId != null,
    staleTime: 30_000,
  });
}

export type { TaskTimeEntryDto };
